import { Component, Host, Input, OnInit, Optional, Self, QueryList, TemplateRef} from '@angular/core';
import { Observable } from 'rxjs';
import { DxControlUtilsService } from './dx-control-utils.service';
import { ConfigStyle } from '../_interfaces/icontrols-common/iconfigstyle.interface';

@Component({
    selector: 'app-base-cmp',
    template: ``,
    providers: [DxControlUtilsService],
    standalone: false
})
export class BaseComponent implements OnInit {
    @Input() id!: string;
    @Input() classNames: string = 'dsep-base';
    @Input() cls!: string;
    @Input() value!: any;
    @Input() configStyle!: ConfigStyle;
    ownerCmp!: object;
    config: any = this;
    componentName: string = 'baseComponent';
    constructor(public _globalSvc: DxControlUtilsService){
       
    }

    ngOnInit(){
        this._globalSvc.registeredComponents[this.config.id] = this;
        this.initConfigStyle();
    }
    initConfigStyle(){
         this.configStyle = {
            width: this.configStyle?.width || 'auto',
            height: this.configStyle?.height || 'auto',
            margin: this.configStyle?.margin || '0px',
            padding: this.configStyle?.padding || '0px',
            boxShadow: this.configStyle?.boxShadow || 'none',
            borderRadius: this.configStyle?.borderRadius || '0px',
            border: this.configStyle?.border || 'none',
            backgroundColor: this.configStyle?.backgroundColor || 'transparent',
            display: this.configStyle?.display || 'block',
            flexDirection: this.configStyle?.flexDirection || 'row',
            justifyContent: this.configStyle?.justifyContent || 'flex-start',
            alignItems: this.configStyle?.alignItems || 'center'
         };
    }
    applyConfig(config: {}){
        this._globalSvc.applyObject(this, this.config, true);
    }

    getComponent(id: string){
       return this._globalSvc.registeredComponents[id];
    }

    addCls(cls: string){
        let arrClass =  this.classNames.split(' ');
        if(arrClass.indexOf(cls) < 0){
            arrClass.push(cls);
            this.classNames = arrClass.join(' ');
        }
    }

    removeCls(cls: string){
        let arrClass =  this.classNames.split(' ');
        if(arrClass.indexOf(cls) >= 0){
            arrClass = arrClass.splice(arrClass.indexOf(cls), 1);
            this.classNames = arrClass.join(' ');
        }
    }
}
